// @ts-nocheck



import CommonApi from './../commonApi';
import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';

const convertDataToServer = (spareParts) => ({
  ...spareParts,
  price: convertFromRubToKop(spareParts.price),
  catalogNumber: spareParts.catalogNumber || ''
});

const convertDataFromServer = (spareParts) => ({
  ...spareParts,
  price: convertFromKopToRub(spareParts.price)
});

const spareParts = new CommonApi(
  'sparePart',
  'Запасные части',
  convertDataToServer,
  convertDataFromServer
);

export default {
  ...spareParts
};
